document.addEventListener('DOMContentLoaded', function () {
    const toggleBtn = document.getElementById('toggleSurveyReadonlyBtn');
    const surveyBoxContent = document.getElementById('surveyBoxContent');
    const container = document.getElementById('surveyStepsContainer');
    const trans = {
        back: container.dataset.transBack,
        accept: container.dataset.transAccept,
        reject: container.dataset.transReject
    };
    const historyBtn = document.querySelector('.rs-history-btn');
    const surveyBox = document.querySelector('.rs-survey-box');

    let isExpanded = false;
    let currentStep = 1;
    const maxStep = 4;
    const commentsData = {};

    const surveyId = document.querySelector('[data-survey-id]')?.dataset.surveyId;

    toggleBtn?.addEventListener('click', function () {
        if (!isExpanded) {
            surveyBoxContent.style.display = 'none';
            container.style.display = 'block';
            loadStep(1);
            isExpanded = true;
        } else {
            container.style.display = 'none';
            surveyBoxContent.style.display = 'block';
            isExpanded = false;
        }
    });

    historyBtn?.addEventListener('click', function (e) {
        e.preventDefault();
        loadHistory();
    });

    function saveCurrentStepComment() {
        const commentField = container.querySelector('textarea[name*="comment"]');
        if (commentField) {
            commentsData[commentField.name] = commentField.value;
        }
    }

    function loadStep(step) {
        saveCurrentStepComment();
        container.innerHTML = '<div class="text-center p-5"><div class="spinner-border" role="status"></div></div>';

        fetch(`/survey/load/${step}/${surveyId}`)
            .then(response => response.text())
            .then(html => {
                container.innerHTML = html;
                currentStep = step;

                const surveyBox = document.querySelector('.b-box-primary.rs-survey-box');
                if (surveyBox) {
                    surveyBox.scrollIntoView({behavior: 'smooth', block: 'start'});
                }

                const commentField = container.querySelector('textarea[name*="comment"]');
                if (commentField && commentsData[commentField.name]) {
                    commentField.value = commentsData[commentField.name];
                }

                const submitBtn = container.querySelector('button[type="submit"]');

                if (step < maxStep) {
                    if (submitBtn) {
                        submitBtn.type = 'button';
                        submitBtn.addEventListener('click', (e) => {
                            e.preventDefault();
                            loadStep(currentStep + 1);
                        });
                    }

                    const prevBtn = container.querySelector('#prevStepBtn');
                    if (prevBtn) {
                        prevBtn.addEventListener('click', (e) => {
                            e.preventDefault();
                            loadStep(currentStep - 1);
                        });
                    }
                } else if (step === maxStep) {
                    submitBtn?.remove();

                    const buttonContainer = container.querySelector('.new-survey-block.new-survey-cta');
                    if (buttonContainer) {
                        const surveyStatus = document.querySelector('[data-survey-status]')?.dataset.surveyStatus;

                        if (surveyStatus === 'accepted') {
                            buttonContainer.innerHTML = `
        <button type="button" id="backBtn" class="btn btn-gray">${trans.back}</button>
    `;
                        } else {
                            buttonContainer.innerHTML = `
        <button type="button" id="backBtn" class="btn btn-gray">${trans.back}</button>
        <button type="button" id="acceptBtn" class="btn btn" style="background-color: #6DB742; color: white; font-size: 1.2rem">${trans.accept}</button>
        <button type="button" id="rejectBtn" class="btn btn-red">${trans.reject}</button>
    `;

                            document.getElementById('acceptBtn')?.addEventListener('click', () => {
                                fetch(`/rabc/survey/${surveyId}/modal/accept`)
                                    .then(response => response.json())
                                    .then(data => {
                                        if (data.needsCustomModal) {
                                            showCustomModal(
                                                data.type,
                                                data.heading,
                                                data.text,
                                                '',
                                                '',
                                                '',
                                                ''
                                            );

                                            setTimeout(() => {
                                                document.getElementById('confirmModalAction')?.addEventListener('click', () => {
                                                    closeCustomModal();
                                                    executeSaveSurveyDecision('accept');
                                                });
                                            }, 100);
                                        }
                                    });
                            });

                            document.getElementById('rejectBtn')?.addEventListener('click', () => {
                                fetch(`/rabc/survey/${surveyId}/modal/reject`)
                                    .then(response => response.json())
                                    .then(data => {
                                        if (data.needsCustomModal) {
                                            showCustomModal(
                                                data.type,
                                                data.heading,
                                                data.text,
                                                '',
                                                '',
                                                '',
                                                ''
                                            );

                                            setTimeout(() => {
                                                document.getElementById('confirmModalAction')?.addEventListener('click', () => {
                                                    closeCustomModal();
                                                    executeSaveSurveyDecision('reject');
                                                });
                                            }, 100);
                                        }
                                    });
                            });
                        }

                        document.getElementById('backBtn').addEventListener('click', () => {
                            loadStep(currentStep - 1);
                        });
                    }
                }
            })
            .catch(error => {
                console.error('Error:', error);
                container.innerHTML = '<div class="alert alert-danger">Błąd ładowania ankiety</div>';
            });
    }

    function loadHistory() {
        const originalContent = surveyBox.innerHTML;

        surveyBox.innerHTML = '<div class="text-center p-5"><div class="spinner-border" role="status"></div></div>';

        fetch(`/rabc/survey/${surveyId}/history`)
            .then(response => response.json())
            .then(data => {
                surveyBox.innerHTML = data.html;

                document.getElementById('closeHistoryBtn')?.addEventListener('click', () => {
                    window.location.reload();
                });
            })
            .catch(error => {
                console.error('Error:', error);
                surveyBox.innerHTML = '<div class="alert alert-danger">Błąd ładowania historii</div>';
            });
    }

    function executeSaveSurveyDecision(action) {
        saveCurrentStepComment();

        const formData = new FormData();
        formData.append('action', action);

        for (const [name, value] of Object.entries(commentsData)) {
            if (value) {
                formData.append(name, value);
            }
        }

        fetch(`/rabc/survey/${surveyId}/save`, {
            method: 'POST',
            body: formData
        })
            .then(response => response.json())
            .then(data => {
                container.style.display = 'none';
                surveyBoxContent.style.display = 'block';
                isExpanded = false;
                window.location.reload();
            })
            .catch(error => {
                console.error('Error:', error);
                alert('Błąd zapisu');
            });
    }
});